module.exports = "<p>\n  admin works!\n</p>\n"